import { createSlice, createEntityAdapter } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/SiteConstants";
import { notifyError, notifySuccess } from "./notification.slice";
import { loginSuccess, authFailCheck } from "./auth.slice";
import BranchService from "../services/BranchService";

const branchAdapter = createEntityAdapter({
  selectId: (branch) => branch.id,
  sortComparer: (a, b) => a.id > b.id,
});

const branchesSlice = createSlice({
  name: "branches",
  initialState: branchAdapter.getInitialState({
    isLoading: false,
  }),
  reducers: {
    fetchRequest(state) {
      state.isLoading = true;
    },
    fetchFail(state, action) {
      state.isLoading = false;
    },
    fetchCurrentBranchSuccess(state, action) {
      const { payload } = action;
      state.isLoading = false;
      branchAdapter.upsertOne(state, payload);
    },
    fetchBranchesSuccess(state, action) {
      const { payload } = action;
      state.isLoading = false;
      branchAdapter.setAll(state, payload);
    },
    updateBranchSuccess(state, action) {
      const { payload } = action;
      state.isLoading = false;
      branchAdapter.upsertOne(state, payload);
    },
    createBranchSuccess(state, action) {
      const { payload } = action;
      state.isLoading = false;
      branchAdapter.addOne(state, payload);
    },
    changeBranchSuccess(state, action) {
      state.isLoading = false;
    },
  },
});

export const {
  fetchRequest,
  fetchFail,
  fetchCurrentBranchSuccess,
  fetchBranchesSuccess,
  updateBranchSuccess,
  createBranchSuccess,
  changeBranchSuccess,
} = branchesSlice.actions;

export default branchesSlice.reducer;

export const branchSelectors = branchAdapter.getSelectors((state) => state.branches);

export const selectCurrentBranch = (state) => {
  const { branchId } = state.auth;
  return branchSelectors.selectById(state, branchId);
};

export const fetchBranchBasedOnRole = (role) => async (dispatch) => {
  if (role === "Admin") {
    dispatch(fetchBranches());
  } else {
    dispatch(fetchCurrentBranch());
  }
};

export const fetchBranches = () => async (dispatch) => {
  dispatch(fetchRequest());
  const response = await BranchService.get();
  if (response.ok) {
    dispatch(fetchBranchesSuccess(response.data));
  } else {
    dispatch(authFailCheck(response));
    fetchFail(response.data);
  }
};

export const fetchCurrentBranch = () => async (dispatch) => {
  dispatch(fetchRequest());
  const response = await BranchService.getCurrent();
  if (response.ok) {
    dispatch(fetchCurrentBranchSuccess(response.data));
  } else {
    dispatch(authFailCheck(response));
    dispatch(fetchFail(response.data));
  }
};

export const updateBranch = (branchId, branch) => async (dispatch) => {
  dispatch(fetchRequest());
  const response = await BranchService.update(branchId, branch);
  if (response.ok) {
    dispatch(notifySuccess("Filial o'zgartirildi."));
    dispatch(updateBranchSuccess({ id: branchId, ...branch }));
  } else {
    dispatch(notifyError(`Filial o'zgartirishda xatolik ro'y berdi: ${response.data}`));
    dispatch(authFailCheck(response));
    dispatch(fetchFail(response.data));
  }
};

export const createBranch = (branch) => async (dispatch) => {
  dispatch(fetchRequest());
  const response = await BranchService.create(branch);
  if (response.ok) {
    const { branchId, token } = response.data;
    localStorage.setItem(AUTH_TOKEN, token);
    dispatch(createBranchSuccess({ id: branchId, ...branch }));
    dispatch(loginSuccess(response.data));
    dispatch(notifySuccess(`${branch.name} filial yaratildi.`));
  } else {
    dispatch(notifyError(`Filial yaratishda xatolik ro'y berdi: ${response.data}`));
    dispatch(authFailCheck(response));
    dispatch(fetchFail(response.data));
  }
};

export const changeBranch = (branchId) => async (dispatch, getState) => {
  dispatch(fetchRequest());
  const response = await BranchService.changeBranch(branchId);
  if (response.ok) {
    localStorage.setItem(AUTH_TOKEN, response.data.token);
    dispatch(loginSuccess(response.data));
    const currentBranch = branchSelectors.selectById(getState(), branchId);
    if (currentBranch) {
      dispatch(notifySuccess(`${currentBranch.name} filial tanlandi`));
    }
    dispatch(changeBranchSuccess());
    window.location.reload();
  } else {
    dispatch(notifyError(`Filial tanlashda xatolik ro'y berdi: ${response.data}`));
    dispatch(authFailCheck(response));
    dispatch(fetchFail(response.data));
  }
};
